import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { PayModeLevel1, PayModeLevel2 } from '@fitness-force/enum';

import { BehaviorSubject } from 'rxjs';
@Component({
  selector: 'payment-mode-other',
  templateUrl: './payment-mode-other.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
  ]
})
export class PaymentModeOtherComponent {

  @Input() columnData = new BehaviorSubject(null);
  @Input() additionData = new BehaviorSubject(null);

  getMode(value: number, data: any) {
    if (value == 0 && (data['paymode_level1'] == PayModeLevel1[PayModeLevel1.Other] || data['paymode_level1'].toString() == PayModeLevel1[PayModeLevel1.Other])) {
      return `${data['paymode_level1']} (${data.payment_mode_master_name_primary_language})`;
    }
    else {
      return value;
    }
  }

}